import { render } from "./edit-product.vue?vue&type=template&id=758f818a"
import script from "./edit-product.vue?vue&type=script&lang=js"
export * from "./edit-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__